import { render, staticRenderFns } from "./OnboardingSlide.vue?vue&type=template&id=0665dffe&scoped=true&"
import script from "./OnboardingSlide.vue?vue&type=script&lang=js&"
export * from "./OnboardingSlide.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSlide.vue?vue&type=style&index=0&id=0665dffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0665dffe",
  null
  
)

export default component.exports